import { render } from "./StudFinderSupport.vue?vue&type=template&id=3465cd36&scoped=true"
import script from "./StudFinderSupport.vue?vue&type=script&lang=js"
export * from "./StudFinderSupport.vue?vue&type=script&lang=js"

import "./StudFinderSupport.vue?vue&type=style&index=0&id=3465cd36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3465cd36"]])

export default __exports__